/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { avatar_user$ref } from "./avatar_user.graphql";
export type reviewsLoadMoreQueryVariables = {|
  spaceRef: string,
  lang?: ?string,
|};
export type reviewsLoadMoreQueryResponse = {|
  +item: ?{|
    +reviews: ?$ReadOnlyArray<?{|
      +type: ?string,
      +rate: ?number,
      +recommend: ?boolean,
      +comment: ?string,
      +createdAt: ?any,
      +rider: ?{|
        +firstname: ?string,
        +company: ?{|
          +name: ?string
        |},
        +$fragmentRefs: avatar_user$ref,
      |},
    |}>
  |}
|};
export type reviewsLoadMoreQuery = {|
  variables: reviewsLoadMoreQueryVariables,
  response: reviewsLoadMoreQueryResponse,
|};
*/


/*
query reviewsLoadMoreQuery(
  $spaceRef: String!
  $lang: String
) {
  item: getSpaceByRef(ref: $spaceRef) {
    reviews {
      type
      rate
      recommend
      comment(lang: $lang)
      createdAt
      rider {
        ...avatar_user
        firstname
        company {
          name
        }
        id
      }
    }
    id
  }
}

fragment avatar_user on User {
  firstname
  lastname
  logo
  avatar {
    nameId
    extension
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceRef"
},
v2 = [
  {
    "kind": "Variable",
    "name": "ref",
    "variableName": "spaceRef"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recommend",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "lang",
      "variableName": "lang"
    }
  ],
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewsLoadMoreQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v2/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceReview",
            "kind": "LinkedField",
            "name": "reviews",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "rider",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "avatar_user"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "reviewsLoadMoreQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v2/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceReview",
            "kind": "LinkedField",
            "name": "reviews",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "rider",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Picture",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nameId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "extension",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a4e7971b4cee4a18b10439c8b709b4c",
    "id": null,
    "metadata": {},
    "name": "reviewsLoadMoreQuery",
    "operationKind": "query",
    "text": "query reviewsLoadMoreQuery(\n  $spaceRef: String!\n  $lang: String\n) {\n  item: getSpaceByRef(ref: $spaceRef) {\n    reviews {\n      type\n      rate\n      recommend\n      comment(lang: $lang)\n      createdAt\n      rider {\n        ...avatar_user\n        firstname\n        company {\n          name\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment avatar_user on User {\n  firstname\n  lastname\n  logo\n  avatar {\n    nameId\n    extension\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71942effee76137373b37260261f4e74';

module.exports = node;
